import { render } from "./verify-slide.vue?vue&type=template&id=0a61cc4e"
import script from "./verify-slide.vue?vue&type=script&lang=js"
export * from "./verify-slide.vue?vue&type=script&lang=js"

import exportComponent from "/home/hudson/workspace/103261_ib-gwms-customer-xc-devops/ib-gwms-customer-xc-devops/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__